// Demo-day escape hatch: operators can set
// `VITE_ADMIN_ROUTES_DISABLED` at build time to a comma-separated
// list of admin route names (the leaf path segment under `/admin/`,
// e.g. "classification,rooms,reviews") and the matching sidebar
// entries are hidden while the corresponding routes render the
// 404 page instead of their stub/page. With the env var unset (or
// blank), behaviour is unchanged: every admin route is visible and
// reachable.
//
// This is a small blast-radius insurance policy for the admin UI
// Phase 0 build — 23+ parallel issues increase the risk that one
// page lands broken close to demo day. See issue #60.

export function parseDisabledAdminRoutes(
  raw: string | undefined,
): ReadonlySet<string> {
  if (raw === undefined) return EMPTY
  const parts = raw
    .split(',')
    .map((part) => part.trim().toLowerCase())
    .filter((part) => part !== '')
  if (parts.length === 0) return EMPTY
  return new Set(parts)
}

export function readDisabledAdminRoutes(
  env: ImportMetaEnv = import.meta.env,
): ReadonlySet<string> {
  return parseDisabledAdminRoutes(env.VITE_ADMIN_ROUTES_DISABLED)
}

export function isAdminRouteDisabled(
  routeName: string,
  disabled: ReadonlySet<string>,
): boolean {
  return disabled.has(routeName.trim().toLowerCase())
}

const EMPTY: ReadonlySet<string> = new Set<string>()
